import { render, staticRenderFns } from "./input-view-verifiction.vue?vue&type=template&id=000ef226&scoped=true&"
import script from "./input-view-verifiction.vue?vue&type=script&lang=js&"
export * from "./input-view-verifiction.vue?vue&type=script&lang=js&"
import style0 from "./input-view-verifiction.vue?vue&type=style&index=0&id=000ef226&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000ef226",
  null
  
)

export default component.exports